export default __webpack_public_path__ + "static/media/RediMinds_Website.5fd5950b.svg";